import {getMediaUrl} from '@/shared/lib/getMediaUrl';
import {type LocalizationKey} from '@/shared/services/i18n';

type LoginStepsCard = {
  image: string;
  titleKey: LocalizationKey;
  descriptionKey: LocalizationKey;
};

export const LOGIN_STEPS_CARD: LoginStepsCard[] = [
  {
    image: getMediaUrl('landing/profile.webp'),
    titleKey: 'landing_steps_create_profile_title',
    descriptionKey: 'landing_steps_share_details_description',
  },
  {
    image: getMediaUrl('landing/discover.webp'),
    titleKey: 'landing_steps_discover_people_title',
    descriptionKey: 'landing_steps_swipe_profiles_description',
  },
  {
    image: getMediaUrl('landing/translate.webp'),
    titleKey: 'landing_steps_connect_beyond_title',
    descriptionKey: 'landing_steps_meaningful_conversations_description',
  },
];
